import styled from '@emotion/styled';
import { typography, colors, spacing } from '../../../../themes';

export const ComparisonPickerWrapper = styled.div`
  display: flex;
  flex-flow: column;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.tiny};
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.tiny};
`;

export const PickerLabel = styled.label`
  ${typography.other.inputLabel};
  color: ${colors.primary.grey};
`;

export const RequiredIndicator = styled.div`
  color: ${colors.primary.grey};
`;

export const ErrorMessageBox = styled.div`
  height: 22px;
  ${typography.body.medium}
  color: ${colors.alerts.error};
  margin-top: ${spacing.tiny};
`;

export const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const DropdownPanel = styled.div`
  position: absolute;
  z-index: 100;
  top: calc(100% + 4px);
  right: 0;
  background-color: #fff;
  border: 1px solid #d6d7d9;
  box-shadow: 0px 12px 32px rgba(51, 51, 51, 0.12);
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 294px;
`;

export const SectionTitle = styled.div`
  font-family: ${typography.fontFamily};
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  color: ${colors.primary.grey};
  text-align: center;
  padding-bottom: 10px;
  margin-top: 2px;
  border-bottom: 1px solid #d6d7d9;
  letter-spacing: 1.2px;
`;

export const PeriodButton = styled.button<{ selected?: boolean }>`
  ${typography.body.large};
  border-radius: ${spacing.tiny};
  border: 1px solid ${colors.primary.blue};
  color: ${colors.primary.blue};
  cursor: pointer;
  padding: ${spacing.tiny} ${spacing.xxsmall};
  background-color: ${({ selected }) => (selected ? colors.primary.blueTint3 : 'transparent')};
  letter-spacing: 0.5px;
  white-space: nowrap;

  &:hover {
    background-color: ${({ selected }) => (selected ? colors.primary.blueTint2 : '#e6e6e6')};
  }

  &:active {
    background-color: ${({ selected }) => (selected ? colors.primary.blueTint1 : '#d6d7d9')};
  }
`;
